import jcf from "../libraries/jcf/jcf";
import jcfCheckbox from "../libraries/jcf/jcf.checkbox";
import jcfRadio from "../libraries/jcf/jcf.radio";

export default function initCustomForms() {
    jcf.setOptions('Select', {
        wrapNative: false,
        fakeDropInBody: false,
        maxVisibleItems: 5
    });
    jcfRadio();
    jcfCheckbox();
    jcf.replaceAll();
}
